module.exports = __webpack_public_path__ + "static/media/text-out.19e96a09.svg";